import React, { useEffect, useState } from "react"
import { Button, CircularProgress, Grid } from "@mui/material"
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf"
import { pdf } from "@react-pdf/renderer"
import AvanceOrdenServicio from "../../pdfs/pdfAvanceOrdenServicio"
import AutocompleteDeluxe from "../../components/AutocompleteDelux"

const ReporteAvance = () => {
  const [loading, setLoading] = useState(false)
  const [ordenServicioData, setOrdenServicioData] = useState(null)
  const [ordeneServiciosList, setOrdenesServiciosList] = useState()

  const mockData = [
    {
      idOrdenServicio: 123,
      fechaSolicitud: "2025-10-01T10:00:00.000Z",
      status: "En Proceso",
      eliminado: null, // Si es null, muestra "Sin Finalizar"
      checklists: {
        datoschecklists: {
          carros: {
            economico: "ECO-01",
            modelo: "2020",
            descripcion: "CAMIONETA URBANA",
            vin: "VIN1234567890",
            marca: "FORD"
          }
        }
      },
      manosObraOrdenServicio: [
        {
          idManoObraOrdenServicio: 1,
          manosObra: {
            descripcion: "Cambio de Aceite",
            tipo: "Mantenimiento",
            claveSat: "12345"
          }
        },
        {
          idManoObraOrdenServicio: 2,
          manosObra: {
            descripcion: "Revision de Frenos",
            tipo: "Reparación",
            claveSat: "67890"
          }
        }
        // ... hasta 20 elementos o más para probar paginación
      ]
    }
  ]

  const loadData = () => {
    // Simular la obtención de datos
    setOrdenServicioData(mockData)
    console.log("Datos de orden de servicio cargados para PDF:", mockData)
  }

  useEffect(() => {
    loadData()
  }, [])

  const generateAndOpenPdf = async () => {
    // **Validar que tengamos datos para el PDF**
    if (!ordenServicioData || ordenServicioData.length === 0) {
      // En un caso real, esto alertaría si no se ha seleccionado/cargado una orden.
      alert(
        "Por favor, cargue los datos de una Orden de Servicio para generar el PDF."
      )
      return
    }

    setLoading(true)
    try {
      // 5. **Pasar los datos al componente PDF**
      const blob = await pdf(
        <AvanceOrdenServicio data={ordenServicioData} />
      ).toBlob()
      const url = URL.createObjectURL(blob)
      window.open(url, "_blank")
    } catch (error) {
      console.error("Error generating PDF:", error)
      alert("Hubo un error al generar el PDF.")
    } finally {
      setLoading(false)
    }
  }

  return (
    <Grid
      container
      spacing={2}
      sx={{ p: 2, display: "flex", flexDirection: "column" }}
    >
      <Grid item>
        <h2>Reporte Avance de la orden de servicio</h2>
        <p>Haga clic en el botón para generar el PDF.</p>
        <AutocompleteDeluxe
          labelToShow="Ordenes de Servicio"
          labelProp="idOrdenServicio"
          nombre="ordenServicio"
          value={ordeneServiciosList}
          setDato={setOrdenesServiciosList}
          background={"#FFFFFF"}
        />
      </Grid>
      <Grid item>
        {!loading ? (
          <Button
            onClick={generateAndOpenPdf}
            variant="contained"
            startIcon={<PictureAsPdfIcon />}
            // Deshabilitar si no hay datos cargados
            disabled={!ordenServicioData}
          >
            Generar PDF
          </Button>
        ) : (
          <CircularProgress size={24} />
        )}
      </Grid>
    </Grid>
  )
}

export default ReporteAvance
